<template>
  <div>
    <c-modal
      v-if="showModal"
      title="Send Me Information"
      size="md"
      @close="closeModal"
    >
      <validation-observer v-slot="{ invalid, valid, errors, ...rest }" ref="form">
        <form @submit.prevent="submit">
          <div class="modal-body">
            <validation-provider vid="fullName" rules="required" v-slot="{errors}">
              <c-input
                label="Full Name"
                v-model="model.fullName"
                required-mark="true"
                :error="errors[0]"
              />
            </validation-provider>

            <validation-provider vid="email" rules="required" v-slot="{errors}">
              <c-input
                type="email"
                label="Email"
                v-model="model.email"
                required-mark="true"
                :error="errors[0]"
              />
            </validation-provider>

            <validation-provider vid="body" v-slot="{errors}">
              <c-textarea
                label="Message"
                v-model="model.body"
                rows="4"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div class="modal-footer">
            <div class="buttons-footer-wrapper">
              <c-button
                theme="default"
                size="md"
                icon="fa-close"
                @click="closeModal"
                uppercase
                fill
              >Close</c-button>

              <c-button
                type="submit"
                theme="success"
                size="md"
                icon="fa-send"
                :show-indicator="showIndicator"
                uppercase
                fill
              >Submit</c-button>
            </div>
          </div>
        </form>
      </validation-observer>
    </c-modal>
  </div>
</template>

<script>
import sponsorsAPI from "../../../api/sponsorsAPI";

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      sponsorId: this.$route.params.sponsorId,
      showIndicator: false,
      model: {
        fullName: '',
        email: '',
        body: ''
      },
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }

        this.showIndicator = true;

        const {fullName, email, body} = this.model;
        const data = {
          fullName: fullName,
          email: email,
          body: body
        };

        sponsorsAPI.sendInfoToExhibitor(this.attendeeId, this.sponsorId, data)
          .then(() => {
            this.closeModal();

            this.model = {
              fullName: '',
              email: '',
              body: ''
            };
          })
          .catch((err) => {
            if (err.errors) {
              this.$refs.form.setErrors(err.errors);
            }
          })
          .finally(() => {
            this.showIndicator = false;
          });

        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      })
    },

    closeModal() {
      this.$emit('update:showModal', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons-footer-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>